import Link from 'next/link';
import React from 'react';

export default function LinkFooter({ children, href, Footer = false }) {
    return (
        <Link prefetch={false} href={href} className="inline-block text-sm text-gray-600 transition-all hover:text-custom-orange-600 hover:translate-x-1">
            {children}
        </Link>
    );
}
